/**
 * 判断是否为编辑器
 */
function isEditor() {
    return !!window.FEGOEditor;
}

/**
 * 判断H5还是Web模式
 * @returns
 */
function isPc() {
    const isEditorMode = isEditor();
    if (isEditorMode) {
        return parseInt(FEGOEditor.app.project.route.now.pageType, 2) === 2;
    } else {
        return parseInt(FEGORender.store.route.now.pageType, 2) === 2;
    }
}
/**
 * 获取当前的页面语言情况
 * @returns
 */
function getPageLang() {
    const isEditorMode = isEditor();
    if (isEditorMode) {
        return FEGOEditor.app.project.route.now.lang;
    } else {
        return FEGORender.store.route.now.lang;
    }
}

export { isEditor, isPc, getPageLang };
